<template>
  <RouterView />
</template>

<script>
import { useAuth } from '@/composables/useAuth';

export default {
  name: 'App',
  setup() {
    const { restoreFromLocalStorage } = useAuth();
    
    // Restaurar estado de autenticación al cargar la app
    restoreFromLocalStorage();
    
    return {};
  }
};
</script>


<style>
button {
  transition: all 0.3s ease-in-out;
}

/* Estilo para navegadores WebKit (Chrome, Safari) */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}


* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Source Sans 3", Roboto, Arial, Helvetica, sans-serif;
}

html {
  height: 100%;
  box-sizing: border-box;
}

body {
  background-color: #f5f5f5;
  height: 100%;
}

a, a:visited{
  color: #f0f0f0
}

#app {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  /* background-color: #111; */
  background-image: url('@/assets/fondo-chatpts-industrial.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  /* background-blend-mode: overlay; */
  background-position: center;
  z-index: 0;
}

#app::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: -1;
  height: 100%;
  /* Capa semi-transparente sobre la imagen */
}

@media screen and (max-width: 768px) {

  html,
  body,
  #app {
    width: 100%;
    justify-content: flex-start;
  }

}
</style>
